<template>
  <div class="plans">
    <h1>在线答辩</h1>
    <a-spin :spinning="liveSpinning">
      <div class="content">
        <div class="result">
          在线答辩：
          <strong>{{ data.length }}门</strong>
        </div>

        <table class="table table-bordered table-hover">
          <tr>
            <!-- <th>房间号</th>
            <th>房间名称</th> -->
            <th style="min-width: 100px">答辩主题</th>
            <th style="min-width: 100px">答辩小组</th>
            <th style="min-width: 80px">答辩顺序</th>
            <th style="min-width: 210px">答辩开始时间</th>
            <th style="min-width: 210px">答辩结束时间</th>
            <th style="min-width: 270px">操作</th>
          </tr>

          <tr v-for="(item, index) in data" :key="index">
            <td class="table-td" style="text-align: center">{{ item.roomName }}</td>
            <td class="table-td" style="text-align: center">{{ item.groupName }}</td>
            <td class="table-td" style="text-align: center">{{ item.defenseSerialNo }}</td>
            <td class="table-td" style="text-align: center">{{ item.startTime }}</td>
            <td class="table-td" style="text-align: center">{{ item.endTime }}</td>
            <td class="table-td">
              <button class="btn btn-inter" style="width: 60px; margin-left: 10px" v-show="show" @click="gotoLiveRoom(item)">进入</button>
            </td>
          </tr>
        </table>
      </div>
    </a-spin>
  </div>
</template>
<script>
export default {
  name: 'DefenseRoomList',
  // props: {
  //   arrs: Array
  // },
  data: function () {
    return {
      show: true,
      columns: [
        {
          title: '房间号',
          dataIndex: 'roomId',
        },
        {
          title: '房间名称',
          dataIndex: 'roomName',
        },
        {
          title: '时间',
          dataIndex: 'times',
        },
      ],
      data: [],
      liveSpinning: true,
      showModal: false,
      returnList: [],
    };
  },

  mounted() {
    this.getDataInfo(); // 远程授课直播列表
  },

  methods: {
    // 时间转化函数
    formatSeconds(value) {
      // var secondTime = parseInt(value);// 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (value > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(value / 60);
        //获取秒数，秒数取佘，得到整数秒数
        value = parseInt(value % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = '' + parseInt(value) + '秒';

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result;
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result;
      }
      return result;
    },

    // 直播列表
    getDataInfo() {
      this.liveSpinning = true;
      this.axios.get(`/biz/live/defenseList`).then((res) => {
        if (res.success) {
          this.liveSpinning = false;
          this.data = res.result;
        }
      });
    },

    // 进入房间 url
    gotoLiveRoom(item) {
      let date1 = new Date(item.endTime);
      let date2 = new Date();
      if (date1 > date2) {
        //结束时间大于当前时间可点击
        this.axios.get(`/biz/live/defenseUrl?id=${item.id}`).then((res) => {
          if (res.success && res.result) {
            window.open(res.result);
          }
        });
      } else {
        this.$message.warning('答辩时间已过期，请点击查看回放!');
      }
    },

    handleClose() {
      this.showModal = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .content {
    background: #fff;
    padding: 28px;
    min-height: 400px;

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      color: #999999;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: $bgColor;
    text-align: center;
    color: #fff;
    border: none;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 6px;
    border-bottom: 1px solid #dee2e6;
  }

  td {
    text-align: center;
    padding: 12px 6px;
    border: 1px solid #dee2e6;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }

  // 最后一个td标签是时间 但是本选择器却在时间中生效
  td:nth-child(3) {
    text-align: left;
    text-indent: 50px;
  }

  // 弹框
  .back {
    background-color: #000;
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .pop {
    background-color: #fff;
    position: fixed;
    top: 200px;
    left: 300px;
    width: calc(100% - 600px);
    z-index: 2;
    padding: 30px 20px 20px 20px;
  }
}

.btn-inter {
  background: $bgColor !important;
  color: #fff;
}

.bgcFFF {
  background: #fff !important;
}

.table-td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/defenseOnline/components/defenseRoomList.vue